import type { MarketScope } from '../../types/marketScope';
import type { CrossMarketStatus } from '../../services/crossMarketApi';
import './MarketScope.css';

interface Props {
  value: MarketScope;
  onChange: (scope: MarketScope) => void;
  status?: CrossMarketStatus | null;
  includeAll?: boolean;
}

const OPTIONS: { value: MarketScope; label: string; caption: string }[] = [
  { value: 'ALL', label: '전체', caption: 'US 운영 + KR 검증' },
  { value: 'US', label: 'US', caption: 'Toss US' },
  { value: 'KR', label: 'KR', caption: 'Toss Replay' },
];

export default function MarketScopeTabs({ value, onChange, status, includeAll = true }: Props) {
  const options = buildOptions(status, includeAll);
  return (
    <div className="market-scope-tabs" aria-label="시장 선택">
      {options.map((option) => (
        <button
          key={option.value}
          aria-label={`시장 ${option.value}`}
          className={value === option.value ? 'active' : ''}
          onClick={() => onChange(option.value)}
          type="button"
        >
          <strong>{option.label}</strong>
          <span>{option.caption}</span>
        </button>
      ))}
    </div>
  );
}

function buildOptions(status?: CrossMarketStatus | null, includeAll = true) {
  const usCaption = isUsLive(status) ? 'Toss Live Pilot' : 'Toss Locked';
  return OPTIONS
    .filter((option) => includeAll || option.value !== 'ALL')
    .map((option) => (
      option.value === 'US' ? { ...option, caption: usCaption } : option
    ));
}

function isUsLive(status?: CrossMarketStatus | null) {
  const safety = status?.safety;
  return Boolean(
    safety?.trading_mode === 'live'
    && safety.live_trading_enabled
    && safety.toss_live_market === 'US'
    && safety.toss_us_live_enabled
  );
}
